<img class="sf-logo" src="/assets/images/sf-logo.svg" alt="sf-logo" routerLink="/" />
<sf-language-selector></sf-language-selector>
